// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1QFE3","footer":"ModalUpdate_footer__2nVXG"};